/* eslint-disable object-curly-newline */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
/* eslint-disable no-debugger */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { InitialIcon } from '../../../../redux/helper/IconGenerator';

export default function TransferOrder({ setaddPopup, OrderDetails, setOrderDetails, distributorDetails, handleAddASE, transferOrder, setTransferUser, transferUser, setError }) {
    const [selectedAse, setselectedAse] = useState(transferUser);
    const [searchKey, setsearchKey] = useState('');
    const handleAdd = () => {
        // const orderDetailsCopy = { ...OrderDetails };
        // orderDetailsCopy.ASEs = selectedAse;
        // setOrderDetails(orderDetailsCopy);
        // handleAddASE(orderDetailsCopy, 'ASE');
        setError();
        setTransferUser(selectedAse);
        setaddPopup(false);
    };
    const handleCheck = (e, item) => {
        const copy = [...selectedAse];
        if (e.target.checked) {
            let exist = false;
            let categoryExist = false;
            const keys = Object.keys(OrderDetails?.items);
            const categories = [];
            const itemsOrder = Object.values(OrderDetails?.items);
            const items = [].concat(...itemsOrder);
            items.forEach((itemCurrent) => {
                categories.push(itemCurrent.MAIN_CATEGORY);
            });
            copy.forEach((element) => {
                element?.PRODUCT_CATEGORIES.forEach((product) => {
                    if (item?.PRODUCT_CATEGORIES.includes(product)) {
                        exist = true;
                    }
                });
            });
            for (let index = 0; index < item?.PRODUCT_CATEGORIES.length; index++) {
                const element = item?.PRODUCT_CATEGORIES[index];
                if (categories.includes(element)) {
                    categoryExist = true;
                    break;
                } else {
                    categoryExist = false;
                }
            }
            if (categoryExist === true) {
                const idx = copy?.map((val) => val?.employee_code || val?.EMPLOYEE_CODE).indexOf(item?.employee_code || item?.EMPLOYEE_CODE);
                if (idx === -1) {
                    copy.push({
                        EMAIL: item?.email,
                        EMPLOYEE_CODE: item?.employee_code || item?.EMPLOYEE_CODE,
                        FIRST_NAME: item?.first_name || item?.FIRST_NAME,
                        LAST_NAME: item?.last_name || item?.LAST_NAME,
                        ROLES: item?.roles || item?.ROLES,
                        PRODUCT_CATEGORIES: item?.product_categories || item?.PRODUCT_CATEGORIES,
                    });
                } else {
                    copy.splice(idx, 1);
                }
            }
        } else {
            const idx = copy.map((val) => val?.employee_code || val?.EMPLOYEE_CODE).indexOf(item?.employee_code || item?.EMPLOYEE_CODE);
            copy.splice(idx, 1);
        }
        const arr = [];
        arr.push(item);
        setselectedAse(arr);
    };
    const handleSearch = (val) => {
        if (searchKey === '') {
            return val;
        } if (val.FIRST_NAME?.toLowerCase().includes(searchKey.toLowerCase())
            || val.LAST_NAME?.toLowerCase().includes(searchKey.toLowerCase())
            || val.EMAIL?.toLowerCase().includes(searchKey.toLowerCase())
            || val.EMPLOYEE_CODE?.toLowerCase().includes(searchKey.toLowerCase())
            || val.POSTAL_CODE?.toLowerCase().includes(searchKey.toLowerCase())) {
            return val;
        }
    };
    const GetRoleName = (role) => {
        if (role.toLowerCase() === 'copec') {
            return 'CSD';
        }
        let name = '';
        const temp = role.split('_');
        for (const i in temp) {
            name += temp[i][0].toUpperCase();
        }
        return name;
    };
    const hierarchy = [
        'area_sales_engineer',
        'area_sales_manager',
        'regional_sales_manager',
        'sales_head',
        'costing',
        'accountant',
        'copec',
    ];

    // Returns TRUE if role is same or higher than next approver
    const canSeeRole = (userRole, nextApproverRole) => {
        const userLevel = hierarchy.indexOf(userRole?.toLowerCase());
        const nextLevel = hierarchy.indexOf(nextApproverRole?.toLowerCase());
        return userLevel >= nextLevel; // higher index = higher level
    };
    return (
        <div className="modal-dialog modal-dialog-centered relative  min-w-[496px] pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                <div className="modal-header flex flex-shrink-0 items-center justify-center pt-5 rounded-t-md relative">
                    <h5 className="text-lg font-semibold text-[#090406]" id="exampleModalScrollableLabel">
                        {transferOrder ? 'Transfer Order' : 'Assign ASE(s)'}
                    </h5>
                    <button onClick={() => setaddPopup(false)} type="button" data-bs-dismiss="modal" aria-label="Close" className="absolute top-[22px] right-[18px]">
                        <img src="/images/Component1587.svg" alt="icon" className="w-3 h-3" />
                    </button>
                </div>
                <div className="modal-body relative py-[18px] pl-10 px-[23px]">
                    <div className="flex items-center w-full search relative">
                        <div className="relative w-full">
                            <input
                                type="text"
                                id="search"
                                onChange={(e) => {
                                    setsearchKey(e.target.value);
                                }}
                                className="px-3.5 h-[35px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-lg text-base font-normal text-[#090406]"
                                placeholder="Search"
                                autoComplete="off"
                            />
                            <label htmlFor="search" />
                        </div>
                        <img src="/images/search.svg" alt="icon" className="absolute top-[12px] right-3.5" />
                    </div>
                    <div className="rounded-lg bg-[#F5F5FA] p-4 mt-3.5 h-[438px] overflow-auto dropdown-menu">
                        {/* <p className="text-xs12 font-semibold text-[#A1A1A1] text-right">
                            {selectedAse.length}
                            {' '}
                            selected
                        </p> */}
                        {((distributorDetails?.TRANSFER_USERS ?? distributorDetails?.SUPPORTS)
                            ?.filter((item) => handleSearch(item) && canSeeRole(item?.ROLES || item?.roles, OrderDetails?.approvals?.next_approval))
                            ?.length > 0) ? (
                                (distributorDetails?.TRANSFER_USERS ?? distributorDetails?.SUPPORTS)
                                    ?.filter((item) => handleSearch(item) && canSeeRole(item?.ROLES || item?.roles, OrderDetails?.approvals?.next_approval))
                                    ?.map((role, i) => (
                                        <div className="w-full" key={role?.EMPLOYEE_CODE}>
                                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-4 flex">
                                                <input
                                                    type="checkbox"
                                                    id={`checkbox-111${i}`}
                                                    checked={(selectedAse[0]?.employee_code || selectedAse[0]?.EMPLOYEE_CODE) === role.EMPLOYEE_CODE}
                                                    onChange={(e) => handleCheck(e, role)}
                                                />
                                                <InitialIcon
                                                    initials={GetRoleName(role?.roles || role?.ROLES)}
                                                    widthValue="30"
                                                    heightValue="30"
                                                    font="10"
                                                    color="090406"
                                                    className="w-[26px] h-[26px] ml-[18px] mr-2"
                                                />
                                                <label htmlFor={`checkbox-111${i}`} className="text-lg font-normal text-[#555259] pl-2">
                                                    {role?.FIRST_NAME || role?.first_name}
                                                    {' '}
                                                    {role?.LAST_NAME || role?.last_name}
                                                    <span className="text-xs12 font-semibold text-[#A1A1A1]">
                                                        {role?.EMPLOYEE_CODE}
                                                    </span>
                                                    <span className="text-xs12 font-semibold text-[#A1A1A1]">
                                                        {role?.PRODUCT_CATEGORIES?.length > 0 && (
                                                            <>
                                                                {role?.PRODUCT_CATEGORIES?.toLocaleString()}
                                                            </>
                                                        )}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    ))
                            ) : (
                                <div className="text-center py-4 text-gray-500 text-[20px]">No users found</div>
                            )}
                        {' '}

                    </div>
                    <div className="flex justify-center mt-2 mb-4">
                        <button
                            disabled={selectedAse.length === 0}
                            onClick={() => handleAdd()}
                            type="button"
                            className="h-[42px] w-[168px] rounded-lg bg-[#555259] py-3 text-xs6 font-semibold text-[#FFFFFF] add-ase inline-block"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
